<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-toolbar-title> Survey Report Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-flex xs12>
            <form>
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header> <v-icon>mdi-filter-variant</v-icon> Filters </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row>
                            <v-flex xs6>
                              <v-text-field
                                v-model="filters.survNo"
                                :label="labels.survNo"
                                :error-messages="errors.collect('survNo')"
                                data-vv-name="survNo"
                                :data-vv-as="labels.survNo"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs6>
                              <v-text-field
                                v-model="filters.verCnt"
                                :label="labels.verCnt"
                                :error-messages="errors.collect('verCnt')"
                                data-vv-name="verCnt"
                                :data-vv-as="labels.verCnt"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                          <v-layout row>
                            <v-flex xs6>
                              <cal-picker v-model="filters.survDate" :label="labels.survDate"></cal-picker>
                            </v-flex>
                            <v-flex xs6>
                              <v-autocomplete
                                :items="survTypeList"
                                v-model="filters.survType"
                                :label="labels.survType"
                                item-text="label"
                                item-value="value"
                                data-vv-name="survType"
                                :data-vv-as="labels.survType"
                                :error-messages="errors.collect('survType')"
                              ></v-autocomplete>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                        <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </form>
          </v-flex>
        </v-card>
        <v-spacer class="mt-2"></v-spacer>
        <v-card>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="items"
              :options.sync="pagination"
              :server-items-length="totalItems"
              :loading="loading"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td class="text-xs-left">{{ row.item.survNo }}</td>
                  <td class="text-xs-left">{{ row.item.verCnt }}</td>
                  <td class="text-xs-left">{{ formatDate(row.item.survDate) }}</td>
                  <td class="text-xs-left">{{ row.item.survType }}</td>
                  <td class="text-xs-center">
                    <v-btn icon color="primary" text type="submit" @click.native="doSelect(row.item)">
                      <v-icon>mdi-content-copy</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatDisplayDate } from '@/utils/date'
export default {
  data() {
    return {
      toogleArray: [false],
      labels: {
        survNo: 'Survey No.',
        verCnt: 'Version Count',
        survDate: 'Survey Date',
        survType: 'Survey Type'
      },
      filters: {
        expDate: '',
        isPolFireRisk: true
      },
      headers: [
        { text: 'Survey No.', value: 'survNo' },
        { text: 'Version Count', value: 'verCnt' },
        { text: 'Survey Date', value: 'survDate' },
        { text: 'Survey Type', value: 'survType' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      survTypeList: [
        { label: '1 - Fire', value: 1 },
        { label: '2 - Burglary', value: 2 },
        { label: '3 - Both', value: 3 }
      ],
      totalItems: 0,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.apiURI
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let massageFilters = clone(this.filters)
          massageFilters.expDate = this.polMaster.expDate
          if (massageFilters.survDate) {
            massageFilters.survDate = this.filters.survDate
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((survMaster) => {
                let survTypeDesc = ''
                switch (parseInt(survMaster.survType)) {
                  case 1:
                    survTypeDesc = '1 - Fire'
                    break
                  case 2:
                    survTypeDesc = '2 - Burglary'
                    break
                  case 3:
                    survTypeDesc = '3 - Both'
                    break
                  default:
                    survTypeDesc = ''
                }

                const convertList = {
                  survNo: survMaster.survNo,
                  verCnt: survMaster.verCnt,
                  survDate: survMaster.survDate,
                  survType: survTypeDesc
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.survNo = null
      this.filters.verCnt = null
      this.filters.survDate = null
      this.filters.survType = null
      this.fetchData(false)
    },
    doSelect(data) {
      this.$emit('assign-survey-report', data)
    },
    formatDate(date) {
      return formatDisplayDate(date)
    }
  },
  computed: {
    polMaster() {
      return this.$store.state.underwriting.policy.polMaster
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin],
  props: {
    apiURI: {
      type: String,
      required: true
    }
  }
}
</script>

<style>
</style>
